<div class="h-100 d-flex flex-column" *ngIf="dobType != 'NOACTION'">
  <app-title></app-title>
	<div class="flex-grow-1" style="overflow: auto;">
    <mat-card class="d-flex flex-row align-items-center" style="margin: auto">
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>{{ formLabel }}</mat-label>
        <input 
          matInput
          #formDateEl
          [formControl]="formDate"
          [minlength]="formStrlen"
          [maxlength]="formStrlen"
          [autofocus]
          (keydown)='change($event)'
          (blur)="format(formDate.value.toString())"
          (keyup.enter)="onClickOk()"
          (input)="onDateInput($event)"
          [placeholder]="formPlaceholder"
        />
        <input [matDatepicker]="picker" type="hidden" (dateChange)="onPickerDateChange($event)" />
        <mat-datepicker-toggle matSuffix [for]="picker" ngClass="btnAnimation"></mat-datepicker-toggle>
        <mat-datepicker
          touchUi
          #picker
          startView="multi-year"
          (yearSelected)="onChosenYearHandler($event, picker)"
          [startAt]="startDate"
        ></mat-datepicker>
        <mat-error *ngIf="formDate.errors?.dobInvalidSubmit">
          {{ loginError }}
        </mat-error>
        <mat-error *ngIf="formDate.errors?.invalid">
          {{'INPUT_INVALID' | translated}}
        </mat-error>
        <mat-error *ngIf="loginError">
        </mat-error>
      </mat-form-field>
    </mat-card>
  </div>

  <div class="row mt-3">
    <div class="col">
      <app-btn
        [dataTxt]="'BACK'"
        (callback)="onClickRetour()"
        [icon]="'chevron-left'"
        [iconLocation]="'left'"
      ></app-btn>
    </div>
    <div class="col text-right">
      <app-btn
        [dataTxt]="'NEXT'"
        [classes]="'btnAnimation'"
        (callback)="onClickOk()"
        [icon]="'chevron-right'"
        [iconLocation]="'right'"
        [disabled]="formDate.errors || formDate.value.toString().trim() == ''"
      ></app-btn>
    </div>
  </div>
</div>
